import cmsService from '~/services/cmsService'

export const useCmsStore = defineStore('CmsStore', {
  state: () => {
    return {
      landing: {},
      conditions: [],
      isInitialized: false,
      error: null
    }
  },
  getters: {},
  actions: {
    async fetch() {
      if (this.isInitialized) {
        return
      }

      try {
        const { cms } = await cmsService.fetch()
        this.landing = cms.landing || {}
        this.conditions = cms.conditions || []
        this.isInitialized = true
        this.error = null
      } catch (e) {
        console.error('CMS STORE ERROR:', e)
        this.error = e
        throw e
      }
    }
  }
})
